const REQUEST_START = 'cv-attribute/REQUEST_START';
const REQUEST_FAILED = 'cv-attribute/REQUEST_FAILED';

const FETCH_REPORT = 'cv-attribute/FETCH_REPORT';
const FETCH_REPORT_SUCCEEDED = 'cv-attribute/FETCH_SUCCEEDED';

const UPDATE_PAGE = 'cv-attribute/UPDATE_PAGE';
const UPDATE_SORT = 'cv-attribute/UPDATE_SORT';

export default {
  REQUEST_START,
  REQUEST_FAILED,

  FETCH_REPORT,
  FETCH_REPORT_SUCCEEDED,

  UPDATE_PAGE,
  UPDATE_SORT,
};
